import AppointmentSurveyForm from '@/modules/provider/pages/AppointmentSurveyForm.vue'
import AppointmentSurveySavedForm from '@/modules/provider/pages/AppointmentSurveySavedForm.vue'
import AppointmentSurveySuccess from '@/modules/provider/pages/AppointmentSurveySuccess.vue'
import SurveyPage from '@/modules/provider/pages/SurveyPage.vue'
import type { RouteRecordRaw } from 'vue-router'

const SettingPage = () => import('@/shared/pages/SettingsPage.vue')
const ProviderLayout = () => import('@/app/layouts/ProviderLayout.vue')
const SharedLayout = () => import('@/app/layouts/SharedLayout.vue')
const DashboardPage = () => import('@/modules/provider/pages/ProviderDashboardPage.vue')
const AppointmentsPage = () => import('@/modules/provider/pages/ProviderAppontmentPage.vue')
const AppointmentDetail = () => import('@/modules/provider/pages/ProviderAppontmentDetailPage.vue')
const MessagesPage = () => import('@/modules/provider/pages/MessagesPage.vue')

export const providerRoutes: RouteRecordRaw[] = [
  {
    path: '/provider',
    component: ProviderLayout,
    meta: { requiresAuth: true, contextType: 'vendor' },
    children: [
      {
        path: 'dashboard',
        name: 'provider.dashboard',
        component: DashboardPage,
        meta: { title: 'Dashboard' }
      }
    ]
  },
  {
    path: '/provider',
    component: SharedLayout,
    meta: { requiresAuth: true, contextType: 'vendor' },
    children: [
      { path: '', redirect: { name: 'provider.dashboard' } },
      {
        path: 'appointments',
        name: 'provider.appointments',
        component: AppointmentsPage,
        meta: { title: 'Appointments' }
      },
      {
        path: 'appointments/:id',
        name: 'provider.appointment.detail',
        component: AppointmentDetail,
        meta: { title: 'Appointment' }
      },
      {
        path: 'appointments/:id/survey',
        name: 'provider.appointment.survey',
        component: AppointmentSurveyForm,
        meta: { title: 'Appointment Survey' }
      },
      {
        path: 'appointments/:id/saved-templates',
        name: 'provider.appointment.saved-templates',
        component: AppointmentSurveySavedForm,
        meta: { title: 'Saved Templates' }
      },
      {
        path: 'surveys/:id/success',
        name: 'provider.survey.success',
        component: AppointmentSurveySuccess,
        meta: { title: 'Back' }
      },
      {
        path: 'messages',
        name: 'provider.messages',
        component: MessagesPage,
        meta: { title: 'Messages' }
      },
      {
        path: 'surveys',
        name: 'provider.surveys',
        component: SurveyPage,
        meta: { title: 'Back' }
      },
      {
        path: 'settings',
        name: 'provider.settings',
        component: SettingPage,
        meta: { title: 'Setting Page' }
      }
    ]
  }
]
